import { IAppliedFilter, EFilterFieldTypes, TParamInfo } from './filters';
import {
  ownerFiltertoParam,
  ownerParamToFilter,
} from './FilterFields/EntityOwnerFilter/utils';

const defaultFiltertoParam = (filter: IAppliedFilter) => ({
  [filter.field.name]: filter.value,
});

const filterToParams = (filter: IAppliedFilter) => {
  switch (filter.field.type) {
    case EFilterFieldTypes.owner:
      return ownerFiltertoParam(filter);
    default:
      return defaultFiltertoParam(filter);
  }
};

export const getQueryParametersFromAppliedFilters = (
  filters: IAppliedFilter[] = []
) =>
  filters.reduce((acc, filter) => ({ ...acc, ...filterToParams(filter) }), {});

const getFilterFromParam = (paramInfo: TParamInfo) => {
  const { baseField } = paramInfo;
  switch (baseField) {
    case EFilterFieldTypes.owner:
      return ownerParamToFilter(paramInfo);
    default:
      return;
  }
};

export const getApliedFiltersFromQueryParams = (
  params: Record<string, string>
) => {
  const filters = Object.entries(params).map(([key, value]) => {
    const [baseField, operation] = key.split('__');
    if (!(baseField in EFilterFieldTypes)) return undefined;
    const filter = getFilterFromParam({ baseField, operation, value });
    return filter;
  });
  return filters.filter(
    (filter): filter is IAppliedFilter => filter !== undefined
  );
};
